/**
 * Contractors Service
 * Handles CRUD operations for contractor management
 */

import { supabase } from '@/lib/supabase';

export const contractorsService = {
  /**
   * Get all contractors for a specific estate
   */
  async listByEstate(estateId) {
    const { data, error } = await supabase
      .from('contractors')
      .select('*')
      .eq('estate_id', estateId)
      .order('name', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  /**
   * Get a single contractor by ID
   */
  async getById(id) {
    const { data, error } = await supabase
      .from('contractors')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    return data;
  },

  /**
   * Create a new contractor
   */
  async create(estateId, contractorData) {
    const { data, error } = await supabase
      .from('contractors')
      .insert([{ ...contractorData, estate_id: estateId }])
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  /**
   * Update an existing contractor
   */
  async update(id, updates) {
    const { data, error } = await supabase
      .from('contractors')
      .update(updates)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  /**
   * Delete a contractor
   */
  async delete(id) {
    const { error } = await supabase
      .from('contractors')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return true;
  },

  /**
   * Assign contractor to an internal issue
   */
  async assignToIssue(issueId, contractorId) {
    const { data, error } = await supabase
      .from('internal_issues')
      .update({ contractor_id: contractorId })
      .eq('id', issueId)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  /**
   * Get contractor assigned to an issue
   */
  async getAssignedContractor(issueId) {
    const { data, error } = await supabase
      .from('internal_issues')
      .select(`
        contractor_id,
        contractors (*)
      `)
      .eq('id', issueId)
      .single();

    if (error) throw error;
    return data?.contractors || null;
  }
};
